import {
  Grid,
  InputAdornment,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { AiOutlineCheck, AiOutlineSearch } from "react-icons/ai";
import { IoMdAdd } from "react-icons/io";
import Admin from "../../components/auth/Admin";
import Controls from "../../components/controls/Controls";
import Notify from "../../components/customHelpers/Notify";
import Popup from "../../components/customHelpers/Popup";
import NewsForm from "../../components/forms/NewsForm";
import Layout from "../../components/layout/Layout";
import News from "../../actions/News";
import useTable from "../../components/customHelpers/useTable";
import { MdOutlineDelete, MdClose } from "react-icons/md";
import { FiEdit, FiEye, FiArrowLeft } from "react-icons/fi";
import Loading from "../../components/customHelpers/Loading";
import Norecords from "../../components/customHelpers/Norecords";
import Notification from "../../components/customHelpers/Notification";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import ViewNews from "../../components/ViewNews";
import NewsDetails from "../../components/NewsDetails";

const headCells = [
  { id: "title", label: "Title" },
  { id: "company", label: "Company" },
  { id: "status", label: "Status" },
  { id: "createdAt", label: "Posted At" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const makeData = (result) => {
  return result.map((data) => {
    // CompaniesNews table uses companyID foreign key
    // The Sequelize association should populate Company object
    const companyName = data.Company?.name || data.companyName || "N/A";

    return {
      title: data.Title || data.title,
      Id: data.Id,
      body: data.Body || data.body,
      author: data.Author || data.author,
      createdAt: data.createdAt,
      company: companyName,
      companyID: data.companyID, // Keep the ID for reference
      status: data.status || "pending",
    };
  });
};
const NewsRequests = () => {
  const { deleteNews, getUserNews, adminApproveNews, approveCompanyNews, rejectCompanyNews, getAllCompanyNewsForAdmin } = News();
  const [openPopup, setOpenPopup] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const { NotifyMessage, notify, setNotify } = Notify();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [values, setValues] = useState({
    loading: false,
    news: [],
    reload: false,
  });
  const { loading, news, reload } = values;
  useEffect(() => {
    getAllNews();
  }, [reload]);
  const getAllNews = () => {
    setValues({
      ...values,
      loading: true,
      error: false,
    });
    getAllCompanyNewsForAdmin().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({ ...values, loading: false });
      } else {
        setValues({
          ...values,
          news: makeData(data.result || []),
          loading: false,
        });
      }
    });
  };

  const onReject = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setOpenPopup(false);
    rejectCompanyNews(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
      }
    });
  };

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["title"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  ?.toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(
      news.sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
      ),
      headCells,
      filterFn
    );

  const onApprove = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setOpenPopup(false);
    approveCompanyNews(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
      }
    });
  };

  const StatusBadge = ({ status }) => {
    const getColor = () => {
      switch (status) {
        case "approved":
          return "#4caf50";
        case "rejected":
          return "#f44336";
        default:
          return "#ff9800";
      }
    };

    return (
      <span
        style={{
          padding: "4px 12px",
          borderRadius: "12px",
          backgroundColor: getColor(),
          color: "white",
          fontSize: "12px",
          fontWeight: "bold",
          textTransform: "uppercase",
        }}
      >
        {status || "pending"}
      </span>
    );
  };
  return (
    <Layout>
      <Admin>
        <div>
          <Grid container alignItems="center" style={{ marginBottom: "20px" }}>
            <Grid item xs={6}>
              <Controls.Button
                text="Back to Dashboard"
                startIcon={<FiArrowLeft />}
                onClick={() => window.history.back()}
                variant="outlined"
                color="default"
              />
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <Typography variant="h6" className="page-header">
                Manage Company News
              </Typography>
            </Grid>
          </Grid>
          <Toolbar>
            <Controls.Input
              label="Search Requests"
              className="searchInput"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
          </Toolbar>
          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <>
                  {" "}
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.Id}>
                            <TableCell>{item.title}</TableCell>
                            <TableCell>{item.company}</TableCell>
                            <TableCell>
                              <StatusBadge status={item.status} />
                            </TableCell>
                            <TableCell>
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>

                            <TableCell>
                              <Controls.ActionButton
                                color="primary"
                                title="View"
                                onClick={() => {
                                  setRecordForEdit(item);
                                  setIsViewMode(true);
                                  setOpenPopup(true);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Approve"
                                disabled={item.status === "approved"}
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: "Are you sure to approve this news?",
                                    subTitle: "It will be marked as Approved.",
                                    onConfirm: () => {
                                      onApprove(item.Id);
                                    },
                                  });
                                }}
                              >
                                <AiOutlineCheck fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="secondary"
                                title="Reject"
                                disabled={item.status === "rejected"}
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: "Are you sure to reject this news?",
                                    subTitle: "It will be marked as Rejected.",
                                    onConfirm: () => {
                                      onReject(item.Id);
                                    },
                                  });
                                }}
                              >
                                <MdClose fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </>
              )}
            </Grid>
          </Grid>
          <Popup
            title={isViewMode ? "News Details" : "News Form"}
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            {isViewMode ? (
              <NewsDetails
                record={recordForEdit}
                onApprove={(Id) => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "Are you sure to approve this news?",
                    subTitle: "It will be marked as Approved.",
                    onConfirm: () => {
                      onApprove(Id);
                    },
                  });
                }}
                onDelete={(Id) => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "Are you sure to reject this news request?",
                    subTitle: "This action will mark the news as rejected.",
                    onConfirm: () => {
                      onReject(Id);
                    },
                  });
                }}
              />
            ) : (
              <NewsForm
                recordForEdit={recordForEdit}
                NotifyMessage={NotifyMessage}
                getAllNews={getAllNews}
                setOpenPopup={setOpenPopup}
              />
            )}
          </Popup>
          <Notification notify={notify} setNotify={setNotify} />
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </div>
      </Admin>
    </Layout>
  );
};

export default NewsRequests;
